module.exports = __webpack_public_path__ + "img/1-1.5abe8ea9.png";